import { ICellRenderer, ICellRendererParams } from '@ag-grid-community/core';
import { AsyncPipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';

import {
  AgCellWrapperComponent,
  ICellWrapperParams,
} from '@shared/ag-components/ag-cell-wrapper/ag-cell-wrapper.component';

import { ForecastTableGridComponent } from '../../forecast-table-grid.component';
import {
  ForecastTableGridDataInterface,
  ForecastTableGridParentComponentContext,
} from '../../models/forecast-table-grid.model';
import { ForecastTableGridMethodCustomCurveComponent } from '../forecast-table-grid-method-custom-curve/forecast-table-grid-method-custom-curve.component';
import { ForecastTableGridMethodPatientComponent } from '../forecast-table-grid-method-patient/forecast-table-grid-method-patient.component';
import { ForecastTableGridMethodSiteComponent } from '../forecast-table-grid-method-site/forecast-table-grid-method-site.component';
import { ForecastTableGridMethodTimeComponent } from '../forecast-table-grid-method-time/forecast-table-grid-method-time.component';

@Component({
  imports: [
    ForecastTableGridMethodSiteComponent,
    ForecastTableGridMethodPatientComponent,
    ForecastTableGridMethodTimeComponent,
    ForecastTableGridMethodCustomCurveComponent,
    AsyncPipe,
  ],
  selector: 'aux-forecast-table-grid-method',
  templateUrl: './forecast-table-grid-method.component.html',
})
export class ForecastTableGridMethodComponent
  extends AgCellWrapperComponent
  implements ICellRenderer
{
  componentParent!: ForecastTableGridComponent;
  context!: ForecastTableGridParentComponentContext;
  data!: ForecastTableGridDataInterface;
  disableMethod = false;
  params!: ICellRendererParams;
  @ViewChild(ForecastTableGridMethodPatientComponent)
  patientComponent!: ForecastTableGridMethodPatientComponent;
  @ViewChild(ForecastTableGridMethodSiteComponent)
  siteComponent!: ForecastTableGridMethodSiteComponent;
  @ViewChild(ForecastTableGridMethodTimeComponent)
  timeComponent!: ForecastTableGridMethodTimeComponent;
  value!: string;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.context = this.params.context;
    this.componentParent = this.context.componentParent;

    if (!this.componentParent.userHasModifyPermissions) {
      this.disableMethod = true;
    }

    this.data = this.params.data;

    if (this.data) {
      this.data.driverSettingId = this.params.data.driverSettingId || undefined;
      this.data.method = this.params.data.method || undefined;
    }

    this.value = this.params.value;
    this.autoTestAttribute = this.getAutoTestAttribute(params);
  }

  getAutoTestAttribute(params: ICellWrapperParams): string {
    const isTotalCell = params.node.rowPinned === 'bottom';

    const field = params.colDef?.field || '';
    const index = params.rowIndex;

    const fieldName = params.customLocator || field;

    return isTotalCell ? `${fieldName}_total` : `${fieldName}_${index}`;
  }

  refresh(): boolean {
    return false;
  }
}
